import { render } from "./AgentPropertyDetails.vue?vue&type=template&id=9d83a47c&scoped=true"
import script from "./AgentPropertyDetails.vue?vue&type=script&lang=js"
export * from "./AgentPropertyDetails.vue?vue&type=script&lang=js"

import "./AgentPropertyDetails.vue?vue&type=style&index=0&id=9d83a47c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d83a47c"]])

export default __exports__